<template>
  <div class="user-wrapper">
    <b-dropdown class="user-action-pill">
      <template #button-content>
        <div>
          <span class="primary">{{ user && user.fullName }}</span>
          <span class="secondary">{{ user && user.phoneNumber }}</span>
        </div>
      </template>
    </b-dropdown>
  </div>
</template>

<script>
import { BDropdown } from 'bootstrap-vue'

export default {
  name: 'UserCell',
  components: {
    BDropdown,
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
}
</script>

<style lang="scss">
.user-wrapper {
  display: flex;
  justify-content: center;
}
.user-action-pill {
  .dropdown-toggle {
    background-color: white !important;
    display: flex;
    align-items: center;
    padding-left: 13px !important;
    border-radius: 40px;
    border-color: transparent !important;
    padding: 4px;
    padding-left: 5px !important;
    padding-right: 10px !important;
    box-shadow: none !important;
    &:after {
      display: none;
    }
    > div {
      display: flex;
      flex-direction: column;
      padding-left: 13px;
      .primary {
        font-size: 14px;
        padding-bottom: 7px;
        color: #565454;
      }
      .secondary {
        color: #bab3b3;
      }
    }
  }
  .dropdown-menu {
    display: none !important;
  }
}
</style>
